import React from "react";
import { Button, useNotify } from "react-admin";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import dataProvider from "server/dataProvider";
import { scholarshipRequests } from "api/scholarshipApi";

const FinalizeDialog = ({ approvedApplications, fetchApprovedApplications, campaignId }) => {
  const notify = useNotify();

  const finalizeCampaign = async () => {
    if (!campaignId) {
      notify("Липсва кампания за финализиране", { type: "error" });
      return false;
    }
    await dataProvider.customRequest(scholarshipRequests.finalizeScholarshipCampaign(campaignId), null, "PUT");
    fetchApprovedApplications();
    notify("Успешно финализирахте кампанията", { type: "success" });
  };

  return (
    <ConfirmModal
      onConfirm={finalizeCampaign}
      titleContent={"Финализиране на кампания"}
      message="Сигурни ли сте, че искате да финализирате кампанията?"
      triggerButton={
        <Button
          label="Финализирай"
          variant="contained"
          color="error"
          size="medium"
          mt={2}
          startIcon={<ThumbUpAltIcon />}
          sx={{ margin: "1rem" }}
        />
      }
    />
  );
};

export default FinalizeDialog;
